import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import { usePaymentDialog } from '../context/PaymentDialogProvider'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './PartialPaymentBanner.module.scss'

export const PartialPaymentBanner = () => {
  const { t } = useTranslation(['Dialogs', 'Common'])
  const { dialogState } = usePaymentDialog()

  if (!dialogState.hasPartialPayment) {
    return null
  }

  return (
    <KibTopLevelAlert
      className={styles.partialPaymentBanner}
      heading={t(
        'Dialogs:ADD_PAYMENT_DIALOG_V2.PARTIAL_PAYMENT_SUCCESS_MESSAGE',
        {
          amount: NumberUtils.formatMoney(dialogState.partialPaymentAmount),
        },
      )}
      severity="success"
    />
  )
}
